(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sk-reveal"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.skRevealInit) return;
    const skip = () => window.Shopify?.designMode
      || matchMedia('(prefers-reduced-motion: reduce)').matches
      || !('IntersectionObserver' in window);

    const io = !skip() && new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-revealed');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    const init = (root) => {
      const type = root.dataset.skReveal;
      const sel = root.dataset.skRevealItems;
      if (!io || !type || type === 'none' || !sel || root.classList.contains('sk-reveal-ready')) return;
      const items = [...root.querySelectorAll(sel)];
      if (!items.length) return;
      if (root.dataset.skRevealDur) root.style.setProperty('--sk-rv-dur', root.dataset.skRevealDur + 'ms');
      if (root.dataset.skRevealStagger) root.style.setProperty('--sk-rv-stagger', root.dataset.skRevealStagger + 'ms');
      items.forEach((el, i) => {
        el.setAttribute('data-sk-item', '');
        el.style.setProperty('--sk-i', Math.min(i, 6));
        io.observe(el);
      });
      root.classList.add('sk-reveal-ready');
    };

    window.skRevealInit = (scope = document) => scope.querySelectorAll('[data-sk-reveal-items]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => window.skRevealInit());
    } else {
      window.skRevealInit();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
